import {
  ANALYTICS_COLOR_1,
  ANALYTICS_COLOR_2,
  ANALYTICS_COLOR_POSTS
} from '../../../config/constants';
import { displayFunctions } from '../../../utils/chartsUtils';
import {
  DEMO_DATA_LINKEDIN_INTERACTIONS_REACTIONS,
  DEMO_DATA_LINKEDIN_OVERVIEW_FOLLOWERS,
  DEMO_DATA_LINKEDIN_OVERVIEW_REACH,
  DEMO_DATA_LINKEDIN_SUMMARY_IMPRESSIONS
} from '../../../utils/demoDataUtils/demoDataArrays';
import { getStaticDataPoints } from '../../../utils/demoDataUtils/demoDataFunctions';

// Configuration matching Firebase data structure for LinkedIn Personal Account
// Firebase structure: profile_followers.linkedin_personal_account, post_reach.linkedin_personal_account

export const followers = {
  addAdditionalPlots: false,

  followers: {
    title: 'mixedChart.followers',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',
    display: displayFunctions.lastValue,
    demo_data_config: {
      func: getStaticDataPoints,
      kwargs: {
        data: DEMO_DATA_LINKEDIN_OVERVIEW_FOLLOWERS
      }
    }
  }
};

export const impressions = {
  addAdditionalPlots: false,

  reach: {
    title: 'mixedChart.reach',
    hexColor: ANALYTICS_COLOR_2,
    type: 'line',
    display: displayFunctions.sum,
    demo_data_config: {
      func: getStaticDataPoints,
      kwargs: {
        data: DEMO_DATA_LINKEDIN_OVERVIEW_REACH
      }
    }
  },
  impressions: {
    title: 'mixedChart.impressions',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',
    display: displayFunctions.sum,
    demo_data_config: {
      func: getStaticDataPoints,
      kwargs: {
        data: DEMO_DATA_LINKEDIN_SUMMARY_IMPRESSIONS
      }
    }
  }
};

export const engagement = {
  addAdditionalPlots: false,

  reactions: {
    title: 'mixedChart.reactions',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',
    display: displayFunctions.sum,
    demo_data_config: {
      func: getStaticDataPoints,
      kwargs: {
        data: DEMO_DATA_LINKEDIN_INTERACTIONS_REACTIONS
      }
    }
  },
  reshares:{
    title: 'mixedChart.reshares',
    hexColor: ANALYTICS_COLOR_POSTS,
    type: 'line',
    display: displayFunctions.sum,
    demo_data_config: {
      func: getStaticDataPoints,
      kwargs: {
        data: DEMO_DATA_LINKEDIN_INTERACTIONS_REACTIONS
      }
    }
  }
};

export const newConfigsMap: any = {
  followers: followers,
  impressions: impressions,
  engagement: engagement,
};
